const reviewSource = ['heureka', 'web'] as const;

export type ReviewSource = (typeof reviewSource)[number];
export const isReviewSource = (x: any): x is ReviewSource => reviewSource.includes(x);

export const REVIEW_RATING_DEFAULT_MIN: number = 0;
export const REVIEW_RATING_DEFAULT_MAX: number = 5;
export const REVIEWS_DEFAULT_PAGE_SIZE: number = 5;

export type ReviewConnectionType = {
    totalCount: number;
    reviews: ReviewType[];
};

export type ReviewType = {
    rating: number;
    reviewSource: ReviewSource;
    createdAt: Date;
    pros: string[];
    cons: string[];
    summary: string | null;
    author: string | null;
    authorOrCustomerNameAnonymized: string | null;
    domainId: number;
};

export type RatingBreakdown = {
    count: number;
    rating: number;
};

export type ReviewsSummary = {
    totalCount: number;
    averageRating: number;
    ratingBreakdowns: RatingBreakdown[];
};
